import { useDispatch } from "react-redux";
import { deleteSetting } from "../../features/settings/settingsSlice";
import { handlePlatformAuth } from "./Assistants.utils";
import { toast } from "react-toastify";

export const useAssistantConnection = ({
  assistant,
  setting,
  setSetting,
  user,
  navigate,
  isDisconnectAction,
}) => {
  const dispatch = useDispatch();

  const connect = async () => {
    try {
      await handlePlatformAuth({
        assistant,
        settingData: setting,
        dispatch,
        updateSetting: setSetting,
        user,
      });
    } catch (err) {
      toast.error(err.message || "Connection failed");
    }
  };

  const disconnect = async (setting) => {
    if (!setting?.uuid) {
      toast.error("No setting found to disconnect");
      return;
    }
    await dispatch(deleteSetting({ uuid: setting.uuid }));
    toast.success("Disconnected successfully");
    navigate("/apps");
  };

  const handleConnectionButton = () => {
    if (isDisconnectAction) {
      disconnect(setting);
    } else {
      connect();
    }
  };

  return { connect, disconnect, handleConnectionButton };
};